import { render } from "./NotificationItem.vue?vue&type=template&id=2d625728&scoped=true&ts=true"
import script from "./NotificationItem.vue?vue&type=script&lang=ts"
export * from "./NotificationItem.vue?vue&type=script&lang=ts"

import "./NotificationItem.vue?vue&type=style&index=0&id=2d625728&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d625728"]])

export default __exports__